import { IDevice } from "@kuika/kuika-cl-model";
import deviceListJson from "../../../../shared/data/device-list.json";
import { selectDesignerViewportDevice } from "../../designer-viewport-actions";
import { getSdInstance } from "../helpers";
import type { ToolHandlerGroup } from "../types";

const deviceList: IDevice[] = (deviceListJson as unknown as IDevice[]) || [];

const DEFAULT_DEVICES: Record<string, string> = {
  Desktop: "fullHd",
  Tablet: "iPadPro",
  Phone: "iPhone16ProMax"
};

export const viewportTools: ToolHandlerGroup = {
  sync: {
    ui_project_get_current_device: () => {
      const sd = getSdInstance();
      const device: IDevice | undefined = sd.designSituationProvider?.state?.selectedDevice;
      if (!device) {
        return { error: "No device selected" };
      }
      return {
        deviceId: device.id,
        model: device.model,
        type: device.type,
        viewport: device.viewport,
        resolution: device.resolution
      };
    },

    ui_project_set_device: (input) => {
      const { deviceId, deviceType } = input;

      if (!deviceId && !deviceType) {
        return { error: 'Either "deviceId" or "deviceType" is required.' };
      }

      const sd = getSdInstance();

      let targetId = deviceId;
      if (!targetId && deviceType) {
        targetId = DEFAULT_DEVICES[deviceType];
        if (!targetId) {
          return {
            error: `Invalid deviceType "${deviceType}". Must be "Desktop", "Tablet", or "Phone".`
          };
        }
      }

      const device = deviceList.find((item: IDevice) => item.id === targetId);
      if (!device) {
        return {
          error: `Device "${targetId}" not found. Use ui_project_list_devices to see available devices.`
        };
      }

      selectDesignerViewportDevice(sd, device);

      return {
        success: true,
        message: `Viewport switched to ${device.model} (${device.viewport})`,
        device: {
          deviceId: device.id,
          model: device.model,
          type: device.type,
          viewport: device.viewport
        }
      };
    },

    ui_project_list_devices: (input) => {
      const { deviceType } = input;

      if (deviceType) {
        const validTypes = ["Desktop", "Tablet", "Phone"];
        if (!validTypes.includes(deviceType)) {
          return {
            error: `Invalid deviceType "${deviceType}". Must be "Desktop", "Tablet", or "Phone".`
          };
        }
      }

      let devices = deviceList;
      if (deviceType) {
        devices = deviceList.filter((d: IDevice) => d.type === deviceType);
      }

      return {
        count: devices.length,
        devices: devices.map((d: IDevice) => ({
          id: d.id,
          model: d.model,
          type: d.type,
          viewport: d.viewport
        }))
      };
    }
  }
};
